import CustomFieldProto from '../../proto/custom-field-proto'
import ListComponent from './components/rag-list'
import ListGroupHeaderComponent from './components/rag-group-list-header'
import TListGroupHeader1Component from './components/rag-group-t-list-header-1'
import ViewComponent from './components/rag-view'
import EditComponent from './components/edit'
import FormComponent from "./components/form"
import FormNewComponent from './components/rag-form-new'
import FieldRagViewInImport from "../../import/view-in-preview/rag-view-in-import"
import normalizeRAG from "../../import/normalize/normalize-rag"

export default class RagCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    listItemGroupFunction() {
        return i=>!_.isNil(i.item.customFieldsData[this.customField.id]) ? i.item.customFieldsData[this.customField.id] : null;
    }

    getCsvValue(item) {
        const { customFieldsData } = item;

        switch (customFieldsData[this.customField.id]) {
            case 0: return 'Red';
            case 1: return 'Amber';
            case 2: return 'Green';
            default: return '';
        }
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.customFieldsData[this.customField.id]],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get TListGroupHeader1Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get TListGroupHeader2Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeRAG(value);
    }

    getComponentViewInImport() {
        return FieldRagViewInImport;
    }

}